import React from "react";
import { useNavigate } from "react-router-dom"; 
import "../styles/HomeBranches.css";

function HomeBranches() {
  const navigate = useNavigate();

  const stateCards = [
    {
      name: "Daman",
      image: "/locations/daman.png", 
      path: "/clients/daman", 
    },
    {
      name: "Maharashtra",
      image: "/locations/Indian-gate.png", 
      path: "/clients/maharashtra", 
    },
    {
      name: "Gujarat",
      image: "/locations/statue.png", 
      path: "/clients/gujarat", 
    },
    {
      name: "Andhra Pradesh",
      image: "/locations/tirupati.png", 
      path: "/clients/andhra-pradesh", 
    },
    {
      name: "Telangana",
      image: "/locations/charminar.png", 
      path: "/clients/telangana", 
    },
  ];

  // scroll to top functionality
  
  const handleCardClick = (path) => {
    window.scrollTo(0, 0); // Scroll to the top of the page immediately
    navigate(path);
  };

  return (
    <div className="home-branches-container">
      <div className="home-branches-header">
        <h2 className="home-branches-title">
          Industrial Catering Across India
        </h2>
        <p className="home-branches-description">
          We proudly serve across India, from industrial cities like Mumbai,
          Kolhapur, and Daman to southern regions like Anantapur. Our services are
          customized for every client—be it large-scale manufacturing units,
          energy sites fully customized according to the client requirements.
        </p>
      </div>

      <div className="home-branches-grid">
        {stateCards.map((state, index) => (
          <div
            className="home-branch-card"
            key={index}
            onClick={() => handleCardClick(state.path)}
          >
            <img
              src={state.image}
              alt={state.name}
              className="home-branch-image"
              title={`${state.name} location`}
              loading="lazy"
            />
            <span className="home-branch-label">{state.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeBranches;
